import { apiRequest } from '../api/http'
import type { SourceAuthority, SourceAuthorityUpdateRequest, SourceDomain } from './types'

const SOURCE_AUTHORITIES_BASE = '/api/source-authorities'

function sourceAuth(accessToken: string) {
  return { accessToken }
}

export function listSourceAuthorities(accessToken: string): Promise<SourceAuthority[]> {
  return apiRequest<SourceAuthority[]>(SOURCE_AUTHORITIES_BASE, '', sourceAuth(accessToken))
}

export function getSourceAuthority(accessToken: string, domain: SourceDomain): Promise<SourceAuthority> {
  return apiRequest<SourceAuthority>(SOURCE_AUTHORITIES_BASE, `/${domain}`, sourceAuth(accessToken))
}

export function updateSourceAuthority(
  accessToken: string,
  domain: SourceDomain,
  payload: SourceAuthorityUpdateRequest,
): Promise<SourceAuthority> {
  return apiRequest<SourceAuthority>(SOURCE_AUTHORITIES_BASE, `/${domain}`, { method: 'PUT', body: payload, accessToken })
}
